$(document).ready(function(){
  document.getElementById("checkout-form").reset();
  poColors = [];
  $('select.colors option').each(function(){
    poColors.push($(this).clone());
  })
  poSizes = [];
  $('select.sizes option').each(function(){
    poSizes.push($(this).clone());
  })
  
  change_variant($("tr.first-row"));

  $('.close').click(function() {
    $('.size-alert').hide();
    $('.color-alert').hide();
  });



  $("#add-to-cart").click(function(){

    var color_choosed = true;
    $('.colors').each(function() {
      if ($(this).val() == "") {

        color_choosed = false
      }

      if( color_option_index == '')
      {
        color_choosed = true
        $('.colors option:nth-child(2)').attr("selected", "selected");
      }      
    });
    
    var size_choosed = true
    $('.sizes').each(function() {
      if ($(this).val() == "") {

        size_choosed = false
      }      
      if( size_option_index == '')
      {
        size_choosed = true
        $('.sizes option:nth-child(2)').attr("selected", "selected");
      }      
    });


    if (color_choosed==false) {
      $('.color-alert').show();
      if (size_choosed==false){
        $('.size-alert').show();
      }else{
        $('.size-alert').hide();
      }

    }else if (size_choosed==false){
      $('.size-alert').show();
      if (color_choosed==false){
        $('.color-alert').show();
      }else{
        $('.color-alert').hide();
      }

    } else if (size_choosed && color_choosed ) {  
      $('.size-alert').hide();      
      var showed=true;        

      var ids = '';
      $(".product-table tbody tr").each(function(){
        var variant = '';
        var qty = $(this).find('.quantity').val();
        var style = $(this).find('.styles option:selected').text();
        var size = $(this).find('.sizes option:selected').text();
        var color = $(this).find('.colors option:selected').text();

        if( size_option_index == '')
        {
          var size=$('.sizes option:nth-child(2)').html();
        }
        if( color_option_index == '')
        {
          var color=$('.colors option:nth-child(2)').html();
        }
        var prLength = productList.variants.length;
        for (var i=0;i<prLength;i++){
          var obj = productList.variants[i];
          if( size_option_index != '' &&  color_option_index != '')
          {
            if (obj['option1'].toLowerCase() == style.toLowerCase() && obj['option3'].toLowerCase() == size.toLowerCase() && obj['option2'].toLowerCase() == color.toLowerCase()){
              variant = obj.id;
              ids += variant + ':';
              ids += qty + ',';
             // alert(obj['id']); 
             // return false;
              if (bypassOption==2) //include the cart page
                CartJS.addItem(variant, qty, {});
            } 
          } 
          if( size_option_index != '' &&  color_option_index == '') {
            if (obj['option1'].toLowerCase() == style.toLowerCase() && obj['option2'].toLowerCase() == size.toLowerCase()){
             variant = obj.id;
              ids += variant + ':';
              ids += qty + ',';
             // alert(obj['id']); 
             // return false;
              if (bypassOption==2) //include the cart page
                CartJS.addItem(variant, qty, {});
              
            }
          } 
          if( color_option_index != '' &&  size_option_index == '') {
            if (obj['option1'].toLowerCase() == style.toLowerCase() && obj['option2'].toLowerCase() == color.toLowerCase()){
              variant = obj.id;
              ids += variant + ':';
              ids += qty + ',';
             // alert(obj['id']); 
             // return false;
              if (bypassOption==2) //include the cart page
                CartJS.addItem(variant, qty, {});
            }
          } 
          if( size_option_index == '' &&  color_option_index == '') {
            if (obj['option1'].toLowerCase() == style.toLowerCase()){
             variant = obj.id;
              ids += variant + ':';
              ids += qty + ',';
             // alert(obj['id']); 
              //return false;
              if (bypassOption==2) //include the cart page
                CartJS.addItem(variant, qty, {});
            }
          }
        }
        

      });

      if (bypassOption==1){ //bypass the cart page

        window.location.href = "http://" + window.location.host + "/cart/" + ids;

      }else{ //include the cart page
        
        jQuery(document).on('cart.requestComplete', function(event, cart) {  
          window.location.href = "http://" + window.location.host + "/cart";

          $("#checkoutModal").modal('hide');
          //$(".cart_button").show();
          //$("#please-wait").hide();
        });
      }

      //CartJS.clear();

    }
    else{
      $('.size-alert').show();
      //alert("Size Can't Be Blank"); 
    }	
    //
    // Set a custom cart note. 
    //CartJS.setNote('This is a custom cart note.');
  });


  /**
  * On Thumbnail click
  */
 $(".product_images .p-thumbs .image a").click( function(){	
    var index = $(this).closest('.image').index();
    $(".styles").find("option:eq(" + index + ")").prop("selected", true);
   if (color_option_index != '') { $(".colors").find("option:eq(" + index + ")").prop("selected", true); }
    $("#styles_m").find("option").prop('selected', false);
    $("#styles_m").find("option:eq(" + index + ")").prop("selected", true);
    $("#styles_m").change();

  }); 



  //buy_it_now
  $("#buy_it_now, #buy_it_now_float").click(function(){
    $(".remove_row").hide();
    $('.product-table tbody tr').each(function(index){
      if(index > 0) {
        $(this).remove();
      }else{
        var id = $("#styles_m").val();
        if(id){
          $("label[for=" + id.replace("style", "swatch") + "]").click();
          
           var color_option_index = color_option_index;
          var select = $(this).closest('tr').find(".colors");
          select.html('<option class="dashed" value=""> --- </option>');
          for ( var i=0; i< poColors.length;i++){
            var color_name = poColors[i].val().split('-')[2];
            if(poColors[i].val().split('-')[3]){
              color_name +='-'+poColors[i].val().split('-')[3];
            }
            var com_d=color_name+' '+poColors[i].val().split('-')[3];
            if(!$(".swatch-element.color."+color_name).hasClass('soldout')) {
              var option = poColors[i].clone();
              if($(".swatch-1-"+color_name).is(":checked")){
                select.append(option.prop("selected", true));
              }else{
                select.append(option);
              }

            }
          }
          
          var size_option_index = size_option_index;
          var select = $(this).closest('tr').find(".sizes");
          select.html('<option class="dashed" value=""> --- </option>');
          for ( var i=0; i< poSizes.length;i++){
            var size_name = poSizes[i].val().split('-')[2];
            if(!$(".swatch-element."+size_name).hasClass('soldout')) {
              var option = poSizes[i].clone();
              select.append(option);	
            }
          }


         

        }else{
          //console.log('sdsds');
          var select = $(this).closest('tr').find(".styles");
          select.html('<option class="dashed" value=""> NA </option>');

          var color_option_index = color_option_index;
          var select = $(this).closest('tr').find(".colors");
          select.html('<option class="dashed" value=""> NA </option>');
          
          var size_option_index = size_option_index;
          var select = $(this).closest('tr').find(".sizes");
          select.html('<option class="dashed" value=""> NA </option>');

          $("#checkoutModal").modal('show');
        }
      }
    });

    $("#checkoutModal").modal('show');
  });


});

/**
* Size Dropdown
*/
$(document).on('change', ".colors",function(){
  var id = $(this).val();
  var styleId = $(this).closest('tr').find('.styles').val();
  if(id){
    $("label[for=" + id.replace("color", "swatch") + "]").click();
    $("label[for=" + styleId.replace("style", "swatch") + "]").click();
    $('#styles_m option[value="'+ styleId +'"]').prop('selected',true);
    change_variant($(this).closest('tr'));
  }
});
$(document).on('change', ".sizes",function(){
  var id = $(this).val();
  var styleId = $(this).closest('tr').find('.styles').val();
  if(id){
    $("label[for=" + id.replace("size", "swatch") + "]").click();
    $("label[for=" + styleId.replace("style", "swatch") + "]").click();
    $('#styles_m option[value="'+ styleId +'"]').prop('selected',true);
    change_variant($(this).closest('tr'));
  }
});



if(accessory_active=='0'){
  if( size_option_index != '')
  {
    var needTable = $('#styles_m').find('option:selected').attr('data-size').replace("'", "");
    var needTtitle = $('#styles_m').find('option:selected').attr('data-title');

    //$('#sizesModal .modal-title strong').html(needTtitle);
    $('.jsTable').hide();
    $('.jsTable.' + needTable ).show();
  }
  if( color_option_index != '')
  {
    var needTable1 = $('#styles_m').find('option:selected').attr('data-color').replace("'", "");
    var needTtitle1 = $('#styles_m').find('option:selected').attr('data-title');

    //$('#colorsModal .modal-title strong').html(needTtitle1);
    $('.jsTable').hide();
    $('.jsTable.' + needTable1 ).show();
  }
}
$('#styles_m').change(function(){
    if( color_option_index != '')
  {
    var needTable1 = $('#styles_m').find('option:selected').attr('data-color').replace("'", "");
    var needTtitle1 = $('#styles_m').find('option:selected').attr('data-title');

    //$('#colorsModal .modal-title strong').html(needTtitle1);


    $('.jsTable').hide();
    $('.jsTable.' + needTable1 ).show();
  }
  if( size_option_index != '')
  {
    var needTable = $('#styles_m').find('option:selected').attr('data-size').replace("'", "");
    var needTtitle = $('#styles_m').find('option:selected').attr('data-title');
    // $('#sizesModal .modal-title strong').html(needTtitle);

    $('.jsTable').hide();
    $('.jsTable.' + needTable ).show();
  }

})



/**
* Style Dropdown
*/
$(document).on('change', ".styles", function(){
  var index = $(this).find("option:selected").index();

  var id = $(this).val();
  var ths = $(this);
  if(id){
    $("label[for=" + id.replace("style", "swatch") + "]").click();
    $('#styles_m option[value="'+ id +'"]').prop('selected',true);
      var color_option_index = color_option_index;
    var select = $(this).closest('tr').find(".colors");
    select.html('<option class="dashed" value=""> --- </option>');
    for ( var i=0 ;i< poColors.length;i++){
      var color_name = poColors[i].val().split('-')[2];
      if(poColors[i].val().split('-')[3]){
        color_name +='-'+poColors[i].val().split('-')[3];
      }
      if(!$(".swatch-element.color."+color_name).hasClass('soldout')) {
        var option = poColors[i].clone();
        select.append(option);	
      }
    }
    
    
    var size_option_index = size_option_index;
    var select = $(this).closest('tr').find(".sizes");
    select.html('<option class="dashed" value=""> --- </option>');
    for ( var i=0 ;i< poSizes.length;i++){
      var size_name = poSizes[i].val().split('-')[2];
      if(!$(".swatch-element."+size_name).hasClass('soldout')) {
        var option = poSizes[i].clone();
        select.append(option);	
      }
    }
  



    change_variant(ths.closest('tr'));
  }
});


/**
* Style Dropdown
*/

$('#buy_it_now').click(function() {
  $('#styles_m').change();
});

jQuery(document).ready(function($) {
  $('.sizes').prepend('<option class="dashed" value=""> --- </option>');
  $('.sizes').find('.dashed').prop('selected', true);
});
jQuery(document).ready(function($) {
  $('.colors').prepend('<option class="dashed" value=""> --- </option>');
  $('.colors').find('.dashed').prop('selected', true);
});


$(document).on('change', "#styles_m", function(){
  var index = $(this).find("option:selected").index();

  var id = $(this).val();
  var ths = $(this);
  if(id){
    $("label[for=" + id.replace("style", "swatch") + "]").click();

    var tr = $(".product-table tbody tr:first");
    tr.find('.styles option:eq(' + index + ')').prop('selected', true); 
    change_variant(tr);
    //$('.styles, .sizes').change(); //Gustavo took it off
  }
});


function change_variant(ths){
  var variant = $('#productSelect').val();
  ths.find(".variant-id").val(variant);
  change_price(ths);
  change_title_price();
}

/**
* remove row
*/
$(document).on("click",".remove_row", function(){	
  $(this).closest("tr").remove();

  if($(".remove_row").length <= 1) {
    $(".remove_row").hide();
  }
});

/**
* Change price
*/
function change_price(ths){
  var selected_variant= $('#productSelect').val();
  ths.find(".v-price").hide();
  ths.find(".v_price-"+selected_variant).show();

}

function change_title_price(){
  var selected_variant= $('#styles_m option:selected').text();
  var result = selected_variant.split('$')[1];
  $('#variantprice').html("$" + result); 
  $('#variantpricem').html("$" + result); 
}